import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import {
  LoginResponse,
  CadastroUsuarioRequest,
  ConviteResponse,
  UsuarioResponse,
  UsuarioParticipanteApiResponse,
  NovaSenhaRequestResponse,
  ParticipanteAuthResponse,
  ConviteRequest,
  UsuarioModelResponse,
  UsuarioEditRequest,
  UsuarioMasterResponse,
  ConviteUsuarioRequest,
  ConviteDataResponse,
} from 'common/genericTypes';

export const LOGINAuth = async (
  dispatch: Dispatch,
  loginInfo: { email: string; senha: string; captchaToken: string; idpToken?: string }
) => {
  return await request(
    () => axiosInstance.post<LoginResponse>(`${requestConfig.api}api/v1/login/auth`, loginInfo),
    dispatch
  );
};

export const GETConsultoreslist = async (dispatch: Dispatch, email: string) => {
  return await request(
    () => axiosInstance.get<{isConsultor: boolean}>(`${requestConfig.api}api/v1/login/consultores`, { params: { email } }),
    dispatch,
    undefined,
    true
  );
};

export const LOGIN = async (dispatch: Dispatch, participanteFuncaoUsuarioId: string) => {
  return await request(
    () => axiosInstance.post<LoginResponse>(`${requestConfig.api}api/v1/login`, { participanteFuncaoUsuarioId }),
    dispatch,
    undefined,
    true
  );
};

export const GETConvite = async (dispatch: Dispatch, conviteId: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<ConviteResponse>(`${requestConfig.api}api/v1/convites/${conviteId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTCadastroUsuário = async (
  dispatch: Dispatch,
  conviteId: string,
  cadastroRequest: CadastroUsuarioRequest,
  stackRequest = false
) => {
  return await request(
    () =>
      axiosInstance.post<UsuarioResponse>(`${requestConfig.api}api/v1/convites/${conviteId}/usuarios`, cadastroRequest),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTNovaSenhaRequest = async (dispatch: Dispatch, email: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.post<NovaSenhaRequestResponse>(`${requestConfig.api}api/v1/nova-senha`, { email }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETNovaSenhaRequest = async (dispatch: Dispatch, id: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<NovaSenhaRequestResponse>(`${requestConfig.api}api/v1/nova-senha/${id}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTNovaSenhaRequest = async (
  dispatch: Dispatch,
  requestId: string,
  senha: string,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.put<UsuarioResponse>(`${requestConfig.api}api/v1/nova-senha/${requestId}`, { senha }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETFuncoes = async (dispatch: Dispatch, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<ParticipanteAuthResponse[]>(`${requestConfig.api}api/v1/usuarios/funcoes`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETUsuarios = async (dispatch: Dispatch, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<UsuarioParticipanteApiResponse[]>(`${requestConfig.api}api/v1/usuarios`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETAllUsuarios = async (dispatch: Dispatch, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<UsuarioModelResponse[]>(`${requestConfig.api}api/v1/usuarios/all`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTConvite = async (dispatch: Dispatch, convite: ConviteRequest, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.post(`${requestConfig.api}api/v1/convites`, convite),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTGerarConvite = async (
  dispatch: Dispatch,
  convite: ConviteUsuarioRequest,
  stackRequest: boolean = false
) => {

  const fileForm = new FormData();
  const { documento, ...conviteRequest } = convite;
  fileForm.append('convite', JSON.stringify(conviteRequest));
  if (documento) fileForm.append('documento', documento);

  return await request(
    () => axiosInstance.post(`${requestConfig.api}api/v1/convites/gerar`, fileForm, { headers: { 'Content-Type': 'multipart/form-data' } }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTReenviarConvite = async (
  dispatch: Dispatch,
  convite: ConviteUsuarioRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post(`${requestConfig.api}api/v1/convites/gerarConvite`, convite),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETConviteByEmail = async (dispatch: Dispatch, email: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<ConviteDataResponse>(`${requestConfig.api}api/v1/convites/findByEmail/${email}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const DELETEUsuario = async (dispatch: Dispatch, usuarioId: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.delete(`${requestConfig.api}api/v1/usuarios/${usuarioId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PATCHAtivarUsuario = async (dispatch: Dispatch, usuarioId: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.patch(`${requestConfig.api}api/v1/usuarios/${usuarioId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PATCHDesbloquearUsuario = async (dispatch: Dispatch, usuarioId: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.patch(`${requestConfig.api}api/v1/usuarios/liberar-bloqueio/${usuarioId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTUsuario = async (dispatch: Dispatch, requestBody: UsuarioEditRequest, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.put(`${requestConfig.api}api/v1/usuarios/${requestBody.id}`, requestBody),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETUsuarioMaster = async (dispatch: Dispatch, emissorId: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<UsuarioMasterResponse>(`${requestConfig.api}api/v1/usuarios/master`, { params: { emissorId } }),
    dispatch,
    undefined,
    stackRequest
  );
};